import { render, staticRenderFns } from "./blackShopOrder.vue?vue&type=template&id=ffe03052&scoped=true&"
import script from "./blackShopOrder.vue?vue&type=script&lang=js&"
export * from "./blackShopOrder.vue?vue&type=script&lang=js&"
import style0 from "./blackShopOrder.vue?vue&type=style&index=0&id=ffe03052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe03052",
  null
  
)

export default component.exports